import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1a2b4a] text-white rounded-t-3xl mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-4 gap-12 mb-12">
          <div className="col-span-1">
            <h3 className="text-3xl font-light mb-4">Stay Informed</h3>
            <p className="text-gray-300 text-sm mb-6">
              Subscribe to receive updates on court filing requirements and service area expansions
            </p>
            <div className="flex flex-col gap-3">
              <input
                type="email"
                placeholder="Your email address"
                className="bg-transparent border-b border-gray-400 pb-2 text-sm text-white placeholder-gray-400 focus:outline-none focus:border-white transition-colors"
              />
              <button className="px-6 py-2.5 bg-white text-black text-sm font-medium rounded-full hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap self-start">
                Subscribe →
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  Process Serving
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  Court Filing
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  Skip Tracing
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  Document Prep
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  Rush Service
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">Resources</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/client-management" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  Client Portal Login
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  Service Areas
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  Pricing
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3 text-sm text-gray-300">
              <div className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>(555) 123-4567</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>info@proservelegal.com</span>
              </div>
              <div className="mt-6">
                <h5 className="text-sm font-semibold mb-2">Office Location</h5>
                <p className="text-sm">1234 Legal Plaza, Suite 500<br />Los Angeles, CA 90012</p>
              </div>
              <div className="mt-4">
                <h5 className="text-sm font-semibold mb-2">Hours</h5>
                <p className="text-sm">24/7 Emergency Service Available</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-600 pt-8 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
              LinkedIn
            </a>
            <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
              Twitter
            </a>
            <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
              Facebook
            </a>
          </div>

          <p className="text-sm text-gray-300">
            © 2025 Professional Process Services. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white underline cursor-pointer">Website Builder</a>
          </p>

          <div className="flex items-center gap-6">
            <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-gray-300 hover:text-white underline transition-colors cursor-pointer">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
